import { ExternalLink } from '@/components/ExternalLink'
import { useHostProfileUrl } from '@/hooks/useHostProfileUrl.ts'

export interface UsePolicyElementsProps {
  beachPrivacyPolicy?: string
  onBookingPolicyDialogOpen(): void
  onRefundPolicyDialogOpen(): void
}

export const usePolicyElements = (props: UsePolicyElementsProps) => {
  const { hostUrl } = useHostProfileUrl()

  const OpenPrivacyPolicyAnchor = (
    <ExternalLink href={`${hostUrl}/privacy-policy/`} isInsideParagraph />
  )

  const OpenBeachPrivacyPolicyAnchor = (
    <ExternalLink href={props.beachPrivacyPolicy} isInsideParagraph />
  )

  const OpenTermsAnchor = (
    <ExternalLink href={`${hostUrl}/terms/`} isInsideParagraph />
  )

  const OpenBookingPolicyDialogButton = (
    <ExternalLink
      as="button"
      isInsideParagraph
      onClick={props.onBookingPolicyDialogOpen}
      type="button"
    />
  )

  const OpenRefundPolicyDialogButton = (
    <ExternalLink
      as="button"
      isInsideParagraph
      onClick={props.onRefundPolicyDialogOpen}
      type="button"
    />
  )

  return {
    OpenBeachPrivacyPolicyAnchor,
    OpenBookingPolicyDialogButton,
    OpenPrivacyPolicyAnchor,
    OpenRefundPolicyDialogButton,
    OpenTermsAnchor,
  }
}
